import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import * as Sentry from '@sentry/react';
import { QA } from '../constants/paths';
import { requestTokenVerification } from '../modules/Authentication/actions/verifyTokenActions';
import AppRoutes from './routes';
import SignIn from '../modules/Authentication/containers/SignInContainer';
import { TOKEN, URL, USERNAME } from '../constants/localStorage';
import './offline.scss';
import Header from './Header/Header';
import { SlideInPagePortal } from '../components/slide-in-page-portal/slide-in-page-portal';
import ScrollToTop from '../components/scroll-to-top/scroll-to-top';
import { ErrorPage } from '../modules/ErrorPage';
import AuthenticationDev from '../modules/authentication-dev/authentication-dev-container';
import { useAuth } from 'react-oidc-context';
import { requestLogout, signInSuccessWithPIAM } from 'modules/Authentication/actions';
import { useLocation } from 'react-router';
import { Loader } from 'components';
const PROD_ENV = 'getservice.get.no';
const PROD_ENV_AWS = 'homeservice.telia.no';
const hostname = window.location.hostname;
const StyledButton = styled.button `
  position: fixed;
  top: 12px;
  left: 16px;
  z-index: 10;
`;
let oldToken = '';
const app = ({ isAuthenticated, isAuthenticatedFetching, requestTokenVerificationFunc }) => {
    const [devLogin, setDevLogin] = useState(false);
    const [showRedirectionModal, setShowRedirectionModal] = useState(true);
    const auth = useAuth();
    const dispatch = useDispatch();
    const location = useLocation();
    const isLoggedInWithOldAuth = useSelector((state) => state.authentication.isLoggedInWithOldAuth);
    const setUserState = () => {
        var _a;
        if (auth.isLoading)
            return;
        if (isLoggedInWithOldAuth)
            return; // if we have old session then ignore this all
        if (auth.user !== null && auth.user !== undefined) {
            const accessToken = auth.user.access_token;
            const isNewToken = localStorage.getItem(TOKEN) !== accessToken;
            // Role is set only by VERIFY_TOKEN_SUCCESS, from the granted authorities
            dispatch(signInSuccessWithPIAM({
                token: accessToken,
                username: (_a = auth.user.profile) === null || _a === void 0 ? void 0 : _a.sub
            }));
            // A stored token is verified on page load; verify here only after a new login or renewal
            if (isNewToken) {
                dispatch(requestTokenVerification({ token: accessToken }));
            }
        }
        else {
            localStorage.removeItem(USERNAME);
            localStorage.removeItem(TOKEN);
            dispatch(requestLogout());
        }
    };
    React.useEffect(() => {
        return auth.events.addUserLoaded(() => {
            setUserState();
        });
    }, [auth.events, auth.signinSilent]);
    React.useEffect(() => {
        setUserState();
    }, [auth.user]);
    const handleClickButton = () => {
        setDevLogin(!devLogin);
    };
    const handleCloseModal = () => {
        setShowRedirectionModal(!showRedirectionModal);
    };
    // Verify the stored token once on page load (refresh); logins start their own verification
    useEffect(() => {
        const storedToken = localStorage.getItem(TOKEN);
        if (storedToken) {
            requestTokenVerificationFunc({ token: storedToken });
        }
    }, []);
    if (window.location.host.includes(QA)) {
        window.onload = () => {
            document.body.id = 'qa';
        };
    }
    else {
        window.onload = () => {
            document.body.id = 'notQa';
        };
    }
    localStorage.setItem(URL, location.pathname + location.hash);
    const showDevLoginButton = () => !isAuthenticated && hostname !== PROD_ENV && hostname !== PROD_ENV_AWS;
    const showDevLoginForm = () => !isAuthenticated &&
        !isAuthenticatedFetching &&
        devLogin &&
        hostname !== PROD_ENV &&
        hostname !== PROD_ENV_AWS;
    return (_jsx(Sentry.ErrorBoundary, { fallback: ErrorPage, children: _jsxs("div", { className: "app__main", children: [localStorage.getItem(URL) && localStorage.getItem(URL) !== location.pathname, _jsx(Header, {}), showDevLoginButton() && (_jsx(StyledButton, { onClick: () => handleClickButton(), children: devLogin ? 'Regular Login' : 'Dev Login' })), _jsxs("div", { className: "main__main-container", children: [showDevLoginForm() && _jsx(AuthenticationDev, {}), !isAuthenticated && !isAuthenticatedFetching && !devLogin && _jsx(SignIn, {}), isAuthenticatedFetching && _jsx(Loader, {}), isAuthenticated && !isAuthenticatedFetching && (_jsx(ScrollToTop, { children: _jsx(AppRoutes, {}) })), _jsx(SlideInPagePortal, { hash: location.hash })] })] }) }));
};
const mapStateToProps = (state) => ({
    close: state.popup.close,
    isAuthenticated: state.authentication.isAuthenticated,
    isAuthenticatedFetching: state.authentication.isFetching,
    popupType: state.popup.popupType,
});
const mapDispatchToProps = (dispatch) => ({
    requestTokenVerificationFunc: (token) => dispatch(requestTokenVerification(token)),
});
export default connect(mapStateToProps, mapDispatchToProps)(app);
